import { ArrowUpRight } from "lucide-react";
import { CANDIDATE } from "../../lib/content";
import { CAREERS_EMAIL } from "../../lib/assets";

export const CandidateBand = () => (
  <section className="bg-cream" data-testid="candidate-band">
    <div className="max-w-7xl mx-auto px-6 md:px-10 pb-4">
      <div className="bg-white border-2 border-navy rounded-3xl shadow-brutal px-6 md:px-10 py-7 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <div className="flex-1">
          <p className="font-display font-bold text-xl md:text-2xl text-navy">{CANDIDATE.headline}</p>
          <p className="font-body text-navy/70 mt-1 max-w-2xl">{CANDIDATE.body}</p>
        </div>
        <a
          href={`mailto:${CAREERS_EMAIL}`}
          data-testid="candidate-cta"
          className="inline-flex items-center justify-center gap-2 shrink-0 bg-sky text-navy border-2 border-navy px-6 py-3 rounded-full font-body font-bold shadow-brutal hover:-translate-y-1 hover:shadow-brutal-lg transition-[transform,box-shadow] duration-200"
        >
          {CANDIDATE.cta} <ArrowUpRight className="w-5 h-5" />
        </a>
      </div>
    </div>
  </section>
);
